import { Row, Col } from "antd";
import React from "react";
import ListArrow from "../../../Assets/listArrow.svg";
import RightIcon from "../../../Assets/rightIcon.svg";

function MobilzationTransferCampaignDropdown({
  item,
  setInviteIds,
  inviteIds,
  setNewAdvertId,
  setSelectedAdverts,
  selectedAdverts,
  setfilterDataAdvert,
  setadvertIds,
  handleOkBtn,
  setids,
  setbadgeIds,
}) {
  const advertIds = item?.adverts?.map((adv) => adv._id) || [];
  const allSelected = advertIds.every((id) => selectedAdverts.includes(id));

  const handleCampaignClick = () => {
    const isChecked = !allSelected;
    const newSelected = isChecked
      ? [...new Set([...selectedAdverts, ...advertIds])]
      : selectedAdverts.filter((id) => !advertIds.includes(id));

    setSelectedAdverts(newSelected);
    setfilterDataAdvert(newSelected);
    setInviteIds({ ...inviteIds, [item?._id]: newSelected });
    setNewAdvertId(newSelected);
    setadvertIds(newSelected);
    setids(newSelected);
    setbadgeIds(newSelected);
    handleOkBtn();
  };

  const handleItemClick = (id) => {
    const newSelected = selectedAdverts.includes(id)
      ? selectedAdverts.filter((e) => e !== id)
      : [...selectedAdverts, id];

    setSelectedAdverts(newSelected);
    setfilterDataAdvert(newSelected);
    setInviteIds({ ...inviteIds, [item?._id]: newSelected });
    setNewAdvertId(newSelected);
    setadvertIds(newSelected);
    setids(newSelected);
    setbadgeIds(newSelected);
    handleOkBtn();
  };

  return (
    <div className="inviteCampaignDropDown">
      <Row
        align="middle"
        gutter={12}
        justify="space-between"
        className={`campaignContainer cursor-pointer ${
          allSelected ? "activeCampaign" : ""
        }`}
        onClick={handleCampaignClick}
      >
        <Col flex="auto" className="name">
          {item?.name}
        </Col>
      </Row>

      <div className="advertContainer">
        {item?.adverts?.map((data) => (
          <Row
            key={data?._id}
            align="middle"
            gutter={8}
            justify="space-between"
            className={`cursor-pointer ${
              selectedAdverts.includes(data?._id)
                ? "activeAdvertItem"
                : "advertItem"
            }`}
            onClick={() => handleItemClick(data?._id)}
          >
            <Col style={{ width: "calc(100% - 36px)" }}>
              <Row align="middle" gutter={8}>
                <Col>
                  <img src={ListArrow} alt="icon" />
                </Col>
                <Col className="name">{data?.jobTitle?.name}</Col>
              </Row>
            </Col>
            {selectedAdverts.includes(data?._id) && (
              <Col>
                <img src={RightIcon} alt="selected" />
              </Col>
            )}
          </Row>
        ))}
      </div>
    </div>
  );
}

export default MobilzationTransferCampaignDropdown;
